export default {
  device: {
    sensor: 'Select Sensor',
    gateway: 'Gateway',
    display: 'Show Label',
    relay: 'Repeater',
    sensor_code: 'ID/SN',
    sensor_type: 'Sensor Type',
    sensor_status: 'Sensor Status',
    transmit_power: 'TX Power',
    channel_mask: 'Channel Mask',
    in_net_interval: 'Join Interval(s)',
    sample_interval: 'Sampling(s)',
    current_probe_value: 'Latest Reading',
    exception_sample_interval: 'Abnormal Sampling(s)',
    temp_sample_interval: 'Temp Sampling(s)',
    hum_sample_interval: 'RH Sampling(s)',
    temp_change_threshold: 'Temp Change Threshold',
    hum_change_threshold: 'RH Change Threshold',
    max_temp_report_interval: 'Max Temp Report(s)',
    max_hum_report_interval: 'Max RH Report(s)',
    min_temp_report_interval: 'Min Temp Report(s)',
    min_hum_report_interval: 'Min RH Report(s)',
    forward_gateway: 'Forwarding Gateway',
    high_temp: 'Hight Temperature',
    low_temp: 'Low Temperature',
    config_log: 'Configuration Log',
    running_status: 'Status',
    gateway_name: 'Gateway Name',
    display_name: 'Display Name',
    display_nickname: 'Display Nickname',
    gateway_nickname: 'Nickname',
    gateway_type: 'Gateway Type',
    gateway_status: 'Gateway Status',
    configured: 'Configure or not',
    mac_address: 'MAC',
    associated_gateway_details: 'View Gateway Details',
    long_addr: 'Long Address',
    short_addr: 'Short Address',
    activated: 'Activated or Not',
    gateway_serial_num: 'Gateway SN',
    belong_carrier: 'Select Asset',
    zigbee_param_status: 'ZigBee Parameter Status',
    power_status: 'Power Status',
    tcp_conn_status: 'TCP Connection Status',
    lte_conn_status: 'LTE Connection Status',
    flight_mode: 'Fight Mode',
    no_flight_mode: 'Airplane Mode Off',
    self_ip: 'Self IP Attribute',
    gateway_no_report: 'The gateway has not obtained the Zigbee coordinator parameters yet.',
    gateway_normal: 'Gateway reports data normally.',

    no_power_supply: 'Backup Power Active',
    normal_power_supply: 'Power Normal',
    conn_normal: 'Connected',
    conn_abnormal: 'Connection Abnormal',
    LTE_conn_normal: 'LTE Connected',
    LTE_conn_abnormal: 'LTE Connection Abnormal',
    add_net_param: 'New Network Parameters',
    reuse: 'Reactivate',
    modify_customer: 'Edit Company',
    import_data: 'Import Data',
    relay_number: 'Repeater ID',
    relay_type: 'Repeater Type',
    display_type: 'Display Type',
    display_number: 'Display ID',

    wait_config: 'Pending Configuration',
    configuring: 'Configuring',
    heartbeat_history: 'Heartbeat History',
    config_status: 'Config Status',
    gateway_mac: 'Gateway MAC',
    heartbeat_on: 'Heartbeat Record',
    stop_time: 'Deactivation Time',
    time_zone: 'Time Zone',
    alarm_on: 'Enable Alarm',
    alarm_off: 'Disable Alarm',
    nickname: 'Nickname',
    history_data: 'Historical Data',
    icon_desc: 'The meaning of the icon is as follows,',
    stop_use: 'Disable',

    zoom: 'Zoom',
    device_location: 'Locate Associated Device',
    upload_carrier_img: 'Please upload the attached image',
    select_img: 'Select Picture',
    upload: 'Upload System Logo',
    tip_before_location: 'Please upload the floor plan firstly before positioning.',

    temp_range: 'Temperature Range',
    hum_range: 'Humidity Range',
    temp_val: 'Temp. Reading',
    hum_val: 'RH Value',
    sample_value: 'Reading',

    calibration_expiration_date: 'Please enter the calibration due date.',
    calibration_notice: 'Calibration Notification',
    add_notification_object: 'New Notification Recipient',
    advance: 'Advance Notification',
    notice: 'Notice',
    calibration_expiration: 'Calibration Due',
    import_calibration_info: 'Import Calibration Information',
    download_calibration: 'Download Calibration Template',
    start_calibration: 'Enable Calibration Verification',
    no_calibration: 'Calibration-free',
    calibration_notice_time_tips: 'Calibration notification time cannot be earlier than the current time',
    no_set_calibration: 'No Calibration Setting',

    switch_type: 'Switch Mode',
    intelligent_switch: 'Smart Switch',
    manual_switch: 'Manual Switch',
    direct_switch: 'Switch Now',
    cancel_switch: 'Cancel Switch',
    intelligent_switch_desc: 'The system will monitor the device against installation point conditions and automatically switch the device when conditions are met.',
    manual_switch_desc: 'Switch timing is manual.',
    direct_switch_desc: 'Skip all processes and switch the selected device immediately.',
    cancel_switch_desc: 'Enter a number ≥ 0. If the switch operation exceeds this time, the system will revert to the original settings. Enter 0 or leave it blank for never expires.',
    remaining_switch_time: 'Remaining Switch Time',
    switch_operation: 'Switch Operation',
    start_switch: 'Start Switch',
    history: 'Historical Data',
    switch_now: 'Start device switch immediately?',
    stop_switch: 'Terminate Switch',
    complete_switch: 'Confirm Switch',
    switch: 'On/Off',
    not_reached: 'Switch Conditions Not Met',
    eligible: 'Matching',
    user_switch: 'Switch by User',
    ignore_switch: 'Switch without checking conditions.',
    user_stop: 'Terminated by user',
    switch_result_notice: 'Switch Result Notification',
    device_switch_notice: 'Device Switching Notification',
    time: 'Time',
    switch_carrierName_tips: 'The device to be switched is associated with a sensor point. Do you want to unbind the sensor point, then do the switch operation?',
    device_not_bind: 'No device bound',
    please_enter_sample_interval: 'Please enter the sampling interval.',
    normal_reporting_interval: 'Normal Report(s)',
    please_enter_normal_reporting_interval: 'Please enter the normal reporting interval.',
    abnormal_reporting_interval: 'Abnormal(s)',
    please_enter_abnormal_reporting_interval: 'Please enter the abnormal reporting interval.',
    async_reporting_interval: 'Sync Report(s)',
    fixed_reporting_interval: 'Fixed Report(s)',
    async_sample_interval: 'Sync Sampling(s)',
    max_recording_interval: 'Max. Recording Interval(s)',
    min_recording_interval: 'Min. Recording Interval(s)',
    max_change_amount: 'Max. Change Value',
    alarm_level: 'Alarm Level',
    sample_mode: 'Sampling Mode',
    fix_sample_interval: 'Fixed Sampling(s)',

    // 时区，根据接口数据时区的code划分
    '0': 'Central Time Zone',
    '+1': 'UTC+1',
    '+2': 'UTC+2',
    '+3': 'UTC+3',
    '+4': 'UTC+4',
    '+5': 'UTC+5',
    '+6': 'UTC+6',
    '+7': 'UTC+7',
    '+8': 'UTC+8',
    '+9': 'UTC+9',
    '+10': 'UTC+10',
    '+11': 'UTC+11',
    '+12': 'UTC+12',
    '-1': 'UTC-1',
    '-2': 'UTC-2',
    '-3': 'UTC-3',
    '-4': 'UTC-4',
    '-5': 'UTC-5',
    '-6': 'UTC-6',
    '-7': 'UTC-7',
    '-8': 'UTC-8',
    '-9': 'UTC-9',
    '-10': 'UTC-10',
    '-11': 'UTC-11',
    '-12': 'UTC-12',




  }
}
